module.exports = __webpack_public_path__ + "img/crystal-gold-age.b55dbb3d.png";